/**
 * Warm oder kalt — für WELCHES Modell? (11.10.2026, Ticket 2930)
 *
 * Martin, 02.10.: Unten in der Fußzeile stand „Sonnet, kalt“, obwohl sein Zug schnell lief. Die Fußzeile nennt ein Modell;
 * das Wort „kalt“ kam von einer Auskunft des Servers, die sich auf ein ANDERES Modell beziehen konnte (der Server nahm das
 * zuletzt von irgendeinem Konto genutzte, `letztesEchtesAboModell`). Zwei Quellen, ein Chip. Jetzt fragt die Anzeige nach dem
 * Modell, das sie zeigt (`?modell=`), und behauptet „kalt“ nur, wenn die Auskunft für genau dieses galt.
 *
 * Rein und ohne DOM, damit es sich am Verhalten prüfen lässt: tests/frontend/waerme-modell-2930.test.ts (die Funktionen) und der
 * Block „Ticket 2930“ in tests/frontend/werkzeug-zahl-anruf-2673.test.ts (der echte Chip).
 */

/** Die drei Abo-Modelle, die eine eigene warme Sitzung haben (server/claude-sdk-session.ts, `waermeStand`). */
export type AboModell = "sonnet" | "opus" | "haiku";

/**
 * Das Abo-Modell, das eine Modellkennung nennt („claude-cli-warm-sonnet“, „claude-opus-5-5“) — `""`, wenn sie keines nennt
 * (Gemini, „Claude-Abo“, „Schnell“): dann gibt es nichts, wofür die Warm-Auskunft gelten könnte.
 */
export function aboModellAus(kennung: string | null | undefined): AboModell | "" {
  const m = (kennung ?? "").toLowerCase();
  if (m.includes("opus")) return "opus";
  if (m.includes("sonnet")) return "sonnet";
  if (m.includes("haiku")) return "haiku";
  return "";
}

/** Die Adresse der Auskunft — mit dem gezeigten Modell, wenn es eines nennt. */
export function waermeAdresse(gezeigt: string | null | undefined): string {
  const modell = aboModellAus(gezeigt);
  return modell ? `/api/system/waerme?modell=${modell}` : "/api/system/waerme";
}

/**
 * Gilt „kalt“ für das, was der Chip zeigt?
 *
 * - `auskunftFuer`: das Modell, für das der Server geantwortet hat (`modell` in seiner Antwort), `""` wenn unbekannt.
 * - Zeigt der Chip kein Abo-Modell (Gemini, „Claude-Abo“), bleibt es wie bisher: die Auskunft gilt, wie sie ist.
 * - Zeigt er ein Modell und die Auskunft gilt für ein anderes (das Modell hat nach der Abfrage gewechselt), schweigt die
 *   Anzeige, bis die nächste Abfrage für dieses Modell da ist — lieber nichts als ein falsches „kalt“.
 */
export function kaltFuerChip(kalt: boolean, auskunftFuer: AboModell | "", gezeigt: string | null | undefined): boolean {
  if (!kalt) return false;
  const modell = aboModellAus(gezeigt);
  return modell === "" || auskunftFuer === "" || modell === auskunftFuer;
}
